import { CustomerTypeEnum } from 'types/customer';
import { AccountOption, TaxTypeEnum } from './type';

export const individualAccountOptions: AccountOption[] = [
    {
        title: __('USA'),
        description: __('Open an account with your Social Security Number.'),
        value: TaxTypeEnum.SSN
    },
    {
        title: __('Other Country/Region'),
        description: __('Open an account with your Passport/ID card.'),
        value: TaxTypeEnum.NON_SSN
    }
];
export const iraCustomerTypeOptions: AccountOption[] = [
    {
        title: __('Traditional IRA'),
        description: __(
            'A traditional IRA is a tax-advantaged personal savings plan where contributions may be tax deductible.'
        ),
        value: CustomerTypeEnum.IRA_TRADITIONAL
    },
    {
        title: __('Roth IRA'),
        description: __(
            'A Roth IRA is a tax-advantaged personal savings plan where contributions are not deductible but qualified distributions may be tax free.'
        ),
        value: CustomerTypeEnum.IRA_ROTH
    },
    {
        title: __('Rollover IRA'),
        description: __(
            'A rollover IRA is an account that allows you to move funds from an old retirement account into an IRA account, which helps to preserve the tax-deferred status of your retirement assets'
        ),
        value: CustomerTypeEnum.IRA_ROLLOVER
    }
];
